export const USER_ACTION_TYPES = {
  LOGIN_START: 'user/LOGIN_START',
  LOGIN_FAILED: 'user/LOGIN_FAILED',
  LOGIN_SUCCESS: 'user/LOGIN_SUCCESS',

  SET_IS_LOGGED_IN: 'user/SET_IS_LOGGED_IN'
};
